import z from 'zod';
export const stringSchema = z.string().trim();
export const uuidSchema = z.uuid();
/**
 * ISO 8601 timestamp, as `Date.toISOString()` produces. Every timestamp the API
 * returns goes through that call, so responses declare their date fields with this.
 */
export const isoDateTimeSchema = z.iso.datetime();
export const numberSchema = z.coerce.number();
// `users`/`system_users` store first and last names in a single column split on the first
// space, so a name containing a space breaks that split. Reject it here until those tables
// gain separate columns.
export const lastNameSchema = stringSchema
    .nonempty('姓を入力してください')
    .refine((value) => !value.includes(' '), '姓にスペースを含めることはできません');
export const firstNameSchema = stringSchema
    .nonempty('名を入力してください')
    .refine((value) => !value.includes(' '), '名にスペースを含めることはできません');
// TODO: Delete once all forms and schemas are updated
export const nameSchema = stringSchema.nonempty('名前を入力してください');
export const organizationNameSchema = stringSchema.nonempty('企業名を入力してください');
export const emailSchema = stringSchema
    .nonempty('メールアドレスを入力してください')
    .pipe(z.email('メールアドレスの形式が正しくありません'));
export const currentPasswordSchema = stringSchema.nonempty('現在のパスワードを入力してください');
export const newPasswordSchema = stringSchema.min(8, 'パスワードは8文字以上で入力してください');
export const fileNameSchema = stringSchema.nonempty('ファイル名を入力してください');
// 集計くん専用
export const taskNameSchema = stringSchema.nonempty('タスク名を入力してください');
/**
 * Validates that the string is a valid phone number.
 */
export const phoneNumberSchema = stringSchema
    .nonempty('電話番号を入力してください')
    .pipe(z.string().regex(/^\+?[0-9]{1,15}$/, '電話番号の形式が正しくありません'));
/**
 * Validates that the string is a valid 7-digit Japanese postal code.
 */
export const postalCodeSchema = stringSchema
    .nonempty('郵便番号を入力してください')
    .pipe(z.string().regex(/^[0-9]{7}$/, '7桁の郵便番号を入力してください'));
/**
 * Validates that the string is a valid HTTP or HTTPS URL.
 */
export const httpUrlSchema = stringSchema.nonempty('URLを入力してください').pipe(z.httpUrl({
    error: (issue) => {
        const input = issue.input;
        if (!input.match(/^https?:\/\/.*/)) {
            return 'https:// または http:// から始まるURLを入力してください';
        }
        return 'URLの形式が正しくありません';
    },
}));
/**
 * Extends the given schema with empty string that maps to `null` to allow clearing the field.
 *
 * @example
 * ```typescript
 * const schema = clearable(z.string().trim().nonempty('名前を入力してください'));
 *
 * schema.parse(''); // null
 * schema.parse('John Doe'); // 'John Doe'
 * ```
 */
export function clearable(schema) {
    return schema.or(z.literal('').transform(() => null)).nullish();
}
//# sourceMappingURL=validation-utils.js.map